import React, { useEffect, useState } from 'react'
import Header from '../../Components/Header/Header'
import Footer from '../../Components/Footer/Footer'
import TermsAndConditonsComponent from '../../Components/TermsAndConditons/TermsAndConditonsComponent'
import { GetLocalStorageParsed } from '../utils/page'
const TermsAndConditons = () => {
  const FetchToken = GetLocalStorageParsed("AuthToken");

  const [loginToken, setLoginToken] = useState(FetchToken || null);
    const [loading, setLoading] = useState();
  
  const [formdata, setFormData] = useState({

  })
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>

        <Header setLoginToken={setLoginToken} setLoading={setLoading}/>
        <TermsAndConditonsComponent />
        <Footer />
      </div>
    </>
  )
}

export default TermsAndConditons
